module.exports = __webpack_public_path__ + "static/img/home_version.92ce92b5.png";